import { Clock, User } from "@phosphor-icons/react";

const PRIORITY = {
  urgent: { label: "Urgente", cls: "bg-[#E0000F] text-white" },
  high: { label: "Alta", cls: "bg-amber-500 text-white" },
};

export const daysSince = (iso) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / 86400000) : 0);

export function SourcePill({ source, size = "sm" }) {
  const base = size === "xs" ? "text-[9px] px-1.5 py-px" : "text-[10px] px-2 py-0.5";
  if (source === "cliente") return <span className={`inline-flex items-center font-bold uppercase tracking-wider rounded-sm bg-[#E0000F] text-white ${base}`} data-testid="source-cliente">Máquina de cliente</span>;
  if (source === "piso_de_venta") return <span className={`inline-flex items-center font-bold uppercase tracking-wider rounded-sm bg-[#F97316] text-white ${base}`} data-testid="source-piso">Piso de venta</span>;
  return <span className={`inline-flex items-center font-semibold uppercase tracking-wider rounded-sm bg-zinc-100 text-zinc-500 ${base}`} data-testid="source-inventario">Inventario</span>;
}

// Tarjeta compacta del Kanban: de quién es, qué equipo, una línea de falla y quién la tiene.
export default function TicketCard({ ticket: t, onOpen, dragRef, onDragEnd }) {
  const days = daysSince(t.created_at);
  const pr = PRIORITY[t.priority];
  const labels = t.labels || [];
  return (
    <div
      draggable
      onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; dragRef.current = t.id; }}
      onDragEnd={onDragEnd}
      onClick={() => onOpen(t)}
      className="group bg-white border border-zinc-200 rounded-md p-3 cursor-grab active:cursor-grabbing hover:border-[#002FA7] hover:shadow-md transition-[border-color,box-shadow]"
      data-testid={`card-${t.id}`}
    >
      <div className="flex items-center justify-between gap-2">
        <SourcePill source={t.source} />
        <span className="flex items-center gap-1.5 shrink-0">
          {pr && <span className={`text-[9px] font-bold uppercase tracking-wider px-1.5 py-px rounded-sm ${pr.cls}`} data-testid={`card-priority-${t.id}`}>{pr.label}</span>}
          <span className={`inline-flex items-center gap-1 text-[10px] font-mono-data ${days > 30 ? "text-[#E0000F]" : days > 14 ? "text-amber-600" : "text-zinc-400"}`} title={`${days} días en taller`}><Clock size={10} /> {days}d</span>
        </span>
      </div>
      <div className="font-semibold text-sm text-zinc-900 leading-snug mt-2 line-clamp-1" title={t.product_name} data-testid={`card-name-${t.id}`}>{t.product_name}</div>
      {t.fault_description && (
        <p className="text-xs text-zinc-500 mt-0.5 line-clamp-1 group-hover:text-zinc-700 transition-colors" title={t.fault_description} data-testid={`ticket-fault-${t.id}`}>{t.fault_description}</p>
      )}
      <div className="mt-2.5 flex items-center justify-between gap-2 text-[11px]">
        <span className={`inline-flex items-center gap-1 min-w-0 truncate ${t.technician_name ? "text-zinc-700" : "text-zinc-400 italic"}`} data-testid={`card-tech-${t.id}`}>
          <User size={11} /> {t.technician_name || "Sin asignar"}
        </span>
        {labels.length > 0 && (
          <span className="flex items-center gap-1 shrink-0" data-testid={`card-labels-${t.id}`}>
            {labels.slice(0, 2).map((lb, i) => (
              <span key={i} className="text-[9px] font-semibold px-1.5 py-px rounded-sm max-w-[96px] truncate" style={{ background: `${lb.color || "#52525B"}1f`, color: lb.color || "#52525B" }} title={lb.text}>{lb.text}</span>
            ))}
            {labels.length > 2 && <span className="text-[9px] text-zinc-400" title={labels.slice(2).map((l) => l.text).join(", ")}>+{labels.length - 2}</span>}
          </span>
        )}
      </div>
    </div>
  );
}
